import CustomContainer from "../../components/CustomContainer";
import Banner from "./Components/Banner";
import ProductGrid from "./Components/ProductGrid";

export default function Products() {

    return (
        <>
            <Banner title={"Joias Inovart Gold"} />
            <CustomContainer>
                <ProductGrid />
            </CustomContainer>
        </>
    );
};